var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReenviarAzul(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0097 8.48063L9.20775 7.69031L12.6578 4.24031L9.20775 0.790313L10.0097 0L14.25 4.24031L10.0097 8.48063ZM0 9.86531V7.24031C0 6.25569 0.347625 5.41581 1.04287 4.72069C1.738 4.02544 2.57788 3.67781 3.5625 3.67781H8.67694L5.78944 0.790313L6.59138 0L10.8317 4.24031L6.59138 8.48063L5.78944 7.69031L8.67694 4.80281H3.5625C2.88937 4.80281 2.31488 5.04081 1.839 5.51681C1.363 5.99269 1.125 6.56719 1.125 7.24031V9.86531H0Z",
    fill: "#00BDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReenviarAzul);
export default __webpack_public_path__ + "static/media/reenviar-azul.00d0d78789db088a25593b162f181b6f.svg";
export { ForwardRef as ReactComponent };